const Input = {
  variants: {
    outline: {
      field: {
        bg: 'surface.default',
        borderColor: 'border.strong',
        borderRadius: 'md',
        minH: '44px',
        // Sin esto heredan la escala fluida del cuerpo (16-18px), que en
        // un formulario resulta desproporcionada: el texto escrito y el
        // marcador se ven enormes frente a sus etiquetas.
        fontSize: '14px',
        // Los campos de formulario NO heredan el color del body: los
        // navegadores les aplican su propio color de agente de usuario.
        // Sin esta línea el texto escrito puede quedar invisible, y los
        // puntos de una contraseña no se ven al teclear.
        color: 'text.primary',
        _hover: { borderColor: 'accent.default' },
        _focusVisible: {
          borderColor: 'accent.default',
          boxShadow: 'outline',
        },
        _placeholder: { color: 'text.secondary' },
        // Chrome pinta el autocompletado con su propio fondo oscuro y su
        // propio color de texto, ignorando `bg` y `color`. Solo cede ante
        // `-webkit-text-fill-color` y una sombra interior que tape el
        // fondo. La transición larga evita el destello azul inicial.
        _autofill: {
          textFillColor: 'var(--chakra-colors-text-primary)',
          boxShadow: '0 0 0 1000px var(--chakra-colors-surface-default) inset',
          transition: 'background-color 100000s ease-in-out 0s',
        },
      },
    },
  },
  defaultProps: { variant: 'outline' },
};

export default Input;
